function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 5.2916669 6.6145836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1169",
    transform: "matrix(1.1802891,0,0,1.1936117,-114.20096,-139.23201)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.25,
      strokeLinecap: "square",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect18582",
    width: 4.2333331,
    height: 5.2916665,
    x: 96.883331,
    y: 116.77119
  }), /*#__PURE__*/React.createElement("g", {
    id: "g41942"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.165,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 97.637927,118.00397 h 1.510112",
    id: "path18621"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.165,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 97.637927,118.51807 h 1.510112",
    id: "path21079"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.165,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 97.637927,119.03217 h 2.587563",
    id: "path21081"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.165,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 97.637927,119.54627 h 1.510112",
    id: "path21083"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.165,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 98.114965,120.06037 h 2.110525",
    id: "path21085"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.165,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 97.637927,120.57447 h 2.587563",
    id: "path21087"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.165,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 97.637927,121.08857 h 1.510112",
    id: "path21089"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextOff);
export default __webpack_public_path__ + "static/media/text_off.03d7e0a5feb59256834b85e605f1c92c.svg";
export { ForwardRef as ReactComponent };